import { useState } from "react";
import { saveEventDetails } from "../Api/Event";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import "../Styling/ResetButton.css";

const Event = () => {
  const [eventData, setEventData] = useState({
    EventName: "",
    EventType: "",
    EventDate: "",
    EventLocation: "",
    OrganizerName: "",
    BudgetAllocation: "",
    Department: "",
    ApprovalStatus: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEventData({ ...eventData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveEventDetails(eventData);
      toast.success(`🦄 Event Added Successfully`);
      setEventData({
        EventName: "",
        EventType: "",
        EventDate: "",
        EventLocation: "",
        OrganizerName: "",
        BudgetAllocation: "",
        Department: "",
        ApprovalStatus: "",
      });
      navigate("/viewEvent");
    } catch (error) {
      toast.error(`🦄 Some Error Happen`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">

      <h2 className="fields-title">Event Details</h2>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">

        <Accordion defaultActiveKey="0">

          <AccordionItem eventKey="0">

            <AccordionBody>

              <Row className="g-3">

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Event Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="EventName"
                      value={eventData.EventName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Event Type</Form.Label>
                    <Form.Control
                      type="text"
                      name="EventType"
                      value={eventData.EventType}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Event Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="EventDate"
                      value={eventData.EventDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Event Location</Form.Label>
                    <Form.Control
                      type="text"
                      name="EventLocation"
                      value={eventData.EventLocation}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Organizer Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="OrganizerName"
                      value={eventData.OrganizerName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Budget Allocation</Form.Label>
                    <Form.Control
                      type="number"
                      name="BudgetAllocation"
                      value={eventData.BudgetAllocation}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Department</Form.Label>
                    <Form.Control
                      type="text"
                      name="Department"
                      value={eventData.Department}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

              </Row>

            </AccordionBody>

          </AccordionItem>

        </Accordion>

        <div className="d-flex justify-content-start mt-4">
          <Button
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Event"}
          </Button>
        </div>

      </Form>

    </div>
  );
};

export default Event;